import { AnimatePresence, motion } from "framer-motion";

const EASE_ZIP = [0.76, 0, 0.24, 1];

/* Full-screen denim panels that part like an opening zipper, with a gold pull leading the way. */
export default function ZipperOverlay({ show, onDone, intro = false }) {
    const delay = intro ? 0.95 : 0.12;
    const dur = intro ? 1.05 : 0.8;
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="pointer-events-none fixed inset-0 z-[100]"
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0, transition: { duration: 0.35 } }}
                    data-testid={intro ? "denim-intro" : "route-zipper"}
                >
                    <motion.div
                        style={{ backgroundImage: "url('/img/denim/denim-texture.jpg')" }}
                        className="denim-bg absolute inset-x-0 top-0 h-[50.5%]"
                        initial={{ y: 0 }}
                        animate={{ y: "-101%" }}
                        transition={{ duration: dur, ease: EASE_ZIP, delay }}
                    >
                        <div className="absolute inset-0 bg-obsidian/55" />
                        <div className="zip-teeth-row absolute inset-x-0 bottom-0 h-3" />
                    </motion.div>
                    <motion.div
                        style={{ backgroundImage: "url('/img/denim/denim-texture.jpg')" }}
                        className="denim-bg absolute inset-x-0 bottom-0 h-[50.5%]"
                        initial={{ y: 0 }}
                        animate={{ y: "101%" }}
                        transition={{ duration: dur, ease: EASE_ZIP, delay }}
                    >
                        <div className="absolute inset-0 bg-obsidian/55" />
                        <div className="zip-teeth-row absolute inset-x-0 top-0 h-3" />
                    </motion.div>
                    <motion.div
                        aria-hidden="true"
                        className="absolute inset-y-0 left-1/2 w-2 -translate-x-1/2"
                        initial={{ opacity: 1 }}
                        animate={{ opacity: 0 }}
                        transition={{ delay: delay + dur * 0.7, duration: 0.3 }}
                    >
                        <div className="zip-column h-full w-full" />
                    </motion.div>
                    <div className="absolute left-1/2 top-0 -translate-x-1/2">
                        <motion.div
                            initial={{ y: "-48px" }}
                            animate={{ y: "105vh" }}
                            transition={{ duration: dur, ease: "linear", delay }}
                            onAnimationComplete={onDone}
                            className="grid h-14 w-7 place-items-center rounded-md border-[3px] border-gold bg-obsidian/85 shadow-[0_0_18px_rgba(212,175,55,0.35)]"
                        >
                            <span className="h-2 w-2 rounded-full bg-gold" />
                        </motion.div>
                    </div>
                    {intro && (
                        <motion.div
                            className="absolute inset-0 z-10 grid place-items-center"
                            initial={{ opacity: 1 }}
                            animate={{ opacity: 0 }}
                            transition={{ delay, duration: 0.35 }}
                        >
                            <div className="text-center">
                                <p className="font-display text-5xl font-extrabold uppercase tracking-tight text-ink md:text-6xl">
                                    Urwan<span className="text-gold">.</span>
                                </p>
                                <p className="mt-3 text-[11px] font-mono uppercase tracking-[0.35em] text-gold">
                                    Luxury Denim · Est. Bangalore
                                </p>
                            </div>
                        </motion.div>
                    )}
                </motion.div>
            )}
        </AnimatePresence>
    );
}
